import { Component, HostBinding, TemplateRef, inject } from '@angular/core';
import { ToastService } from '../../services';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-toast',
  templateUrl: 'toast.component.html',
  imports: [NgbToast],
})
export class ToastComponent {
  toastService = inject(ToastService);

  @HostBinding('class.ngb-toasts') ngbToasts = true;

  isTemplate(toast: any) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
